import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { VehicleDetailsLightBoxActions } from '../constants/vehicle_details_light_box/vehicle_details_light_box_actions';

class VehicleDetailsLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.VEHICLE_DETAILS_LIGHTBOX_ACTION) {
            switch (action.type) {
                case VehicleDetailsLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case VehicleDetailsLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;

                case VehicleDetailsLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const VehicleDetailsLightBoxStore = new VehicleDetailsLightBoxStoreClass(Dispatcher);
export { VehicleDetailsLightBoxStore };
